import { createAction, props } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';
import { Group } from '../../models/group.model';
import { SchoolMember } from '../../models/member.school.model';
import { MembershipStatus } from '../../models/membership.status';

export const getStudents = createAction(
  '[Teacher] Get Students',
  props<{
    source: string;
    groupId: string;
    gradeId?: string;
    academicYear?: number;
    status?: MembershipStatus[];
    lastRecord?: SchoolMember;
    limit?: number;
  }>(),
);

export const getStudentsDone = createAction('[Teacher] Get Students Done');

export const addStudentsToStore = createAction(
  '[Teacher] Add Students to store',
  props<{ members: SchoolMember[] }>(),
);
export const addStudentToStore = createAction(
  '[Teacher] Add Student to store',
  props<{ member: SchoolMember }>(),
);

export const getStudent = createAction(
  '[Teacher] Get Student',
  props<{ groupId: string; memberId: string }>(),
);

export const getChildrenByParentId = createAction(
  '[Teacher] Get Children By Parent Id',
  props<{ groupId: string; memberId: string }>(),
);

export const getChildrenDone = createAction(
  '[Teacher] Get Children Done',
  props<{ members: SchoolMember[] }>(),
);

export const getStudentsFailure = createAction(
  '[Teacher] Get Students Failed',
  props<{ error: AppExceptionModel }>(),
);

export const deleteFromStore = createAction(
  '[Teacher] Clear from store',
  props<{ id: string }>(),
);

export const getStudentStats = createAction(
  '[Teacher] Get Student Statistics',
  props<{ groupId: string }>(),
);

export const getStudentStatsDone = createAction(
  '[Teacher] Get Student Statistics Done',
  props<{ group: Group }>(),
);
export const getStudentStatsFailure = createAction(
  '[Teacher] Student Statistics Failure',
  props<{ error: any }>(),
);

export const clear = createAction('[Teacher] Clear Students');
